export default __webpack_public_path__ + "static/media/show.6284aeae.svg";